import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { EnderecoIndigena, TipoEnderecoEnum } from 'graphql/types.generated'

interface ResidenciaSectionProps {
  enderecoIndigena?: EnderecoIndigena
  tipoEndereco?: TipoEnderecoEnum
  numeroFamilia?: string
}

export const EnderecoIndigenaSection = (props: ResidenciaSectionProps) => {
  const { enderecoIndigena, tipoEndereco, numeroFamilia } = props
  return (
    <HeadingSection level={2} title='Localização'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='Localidade'>{tipoEndereco?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='DSEI'>{enderecoIndigena?.dseiResidencia?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Polo Base'>{enderecoIndigena?.poloBaseResidencia?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Aldeia'>{enderecoIndigena?.aldeiaResidencia?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Município da Aldeia'>{enderecoIndigena?.municipio?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='UF'>{enderecoIndigena?.uf?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Número Residência'>{enderecoIndigena?.numero?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Número da família'>{numeroFamilia}</InfoLabel>
        </Cell>
        <Cell size={4} />
      </Grid>
    </HeadingSection>
  )
}
